module.exports = __webpack_public_path__ + "static/media/activities_icon.5399a482.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activities_icon.svg
// module id = 1929
// module chunks = 0